<app-sidebar></app-sidebar>

<div style="position: relative; left: 10px; top: 10px;">
  <div>
    <a (click)="deleteAccess()">تسجيل الخروج</a>
  </div>
</div>

  <div class="add-list">
      <a class="vincent_button" (click)="basicModal2.show()">أضافة قائمة</a>
  </div>

  <!-- add list modal -->
  <div mdbModal #basicModal2="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal2.hide()">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title w-100" id="myModalLabel">أضافة قائمة جديدة</h4>
        </div>
        <div class="modal-body">
          <form #f1="ngForm" (ngSubmit)="addList(f1)">
            <div class="md-form">
              <input mdbInput placeholder="List's Name" ngModel name="title" #title="ngModel" type="text" id="form58" class="form-control" required>
              <label for="form58"> أسم القائمة بالأنجليزية</label>
            </div>
            <div class="md-form">
              <input mdbInput placeholder=" أسم القائمة " ngModel name="title_ar" #title_ar="ngModel" type="text" id="form586" class="form-control" required>
              <label for="form586"> أسم القائمة بالعربية</label>
            </div>
            <input type="submit" value="أدخال" [disabled]="f1.invalid" *ngIf="addlistS == true">
            <div class="status" *ngIf="loading == true">
              <img src="assets/imgs/loading2.gif" style="width: 45px;">
            </div>
            <div class="status" *ngIf="done == true">
              <img src="assets/imgs/done.png" style="width: 45px;">
            </div>
          </form>            
        </div>
        <div class="modal-footer">
          <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal2.hide()" mdbWavesEffect>غلق</button>
        </div>
      </div>
    </div>
  </div>
  <!-- add list modal end-->

  <div class="divX">
   <ngb-tabset class="reverseX">
     
    <ngb-tab class="tabX" *ngFor="let data of menu;">
        <ng-template ngbTabTitle>
            <div (click)="sub(data.id)">{{data.title_ar}}</div>
        </ng-template>
       <ng-template ngbTabContent>
       
        <div class="add-item-to-list">
            <a class="vincent_button" (click)="basicModal3.show()">أضافة صنف</a>
        </div>
        <div class="plz-click" *ngIf="pX">
          <p>الرجاء أختيار من القائمة لعرض البيانات بالجدول</p>
        </div>
        <div class="edit-list">
          <a (click)="basicModal4.show()"><mdb-icon far icon="edit"></mdb-icon></a>
        </div>
        
        <!-- edit list modal -->
        <div mdbModal #basicModal4="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal4.hide()">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 class="modal-title w-100" id="myModalLabel">تعديل القائمة</h4>
              </div>
              <div class="modal-body">
                <div>
                  <div class="md-form">
                    <input mdbInput placeholder="أسم الصنف" [(ngModel)]="data.title" type="text" id="form1" class="form-control" (focus)="onFocus_editListS()">
                    <label for="form1">  أسم القائمة بالأنجليزية</label>
                  </div>
                  <div class="md-form">
                    <input mdbInput placeholder="أسم الصنف" [(ngModel)]="data.title_ar" type="text" id="form11" class="form-control" (focus)="onFocus_editListS()">
                    <label for="form11">  أسم القائمة بالعربية</label>
                  </div>                    
                  <a class="vincent_button btnX" (click)="editList(data.id,data.title,data.title_ar)" *ngIf="editListS==true"> تغير</a>
                  <div class="status" *ngIf="loading == true">
                    <img src="assets/imgs/loading2.gif" style="width: 45px;">
                  </div>
                  <div class="status" *ngIf="done == true">
                    <img src="assets/imgs/done.png" style="width: 45px;">
                  </div>      
                </div>
                <a class="vincent_button" (click)="deleteList(data.id)">حذف القائمة</a>            
              </div>
              <div class="modal-footer">
                <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal4.hide()" mdbWavesEffect>غلق</button>
              </div>
            </div>
          </div>
        </div>
        <!-- edit list modal end-->

        <!-- add item to the list modal -->
        <div mdbModal #basicModal3="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal3.hide()">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 class="modal-title w-100" id="myModalLabel">أضافة صنف جديد</h4>
              </div>
              <div class="modal-body">
                <form #f2="ngForm" (ngSubmit)="addItemToMenu(f2,data.id)">
                  <div class="md-form">
                    <input mdbInput placeholder="أسم الصنف" ngModel name="title" #title="ngModel" type="text" id="form1" class="form-control" required>
                    <label for="form1">  أسم الصنف بالأنجليزية</label>
                  </div>
                  <div class="md-form">
                    <input mdbInput placeholder="أسم الصنف" ngModel name="title_ar" #title_ar="ngModel" type="text" id="form11" class="form-control" required>
                    <label for="form11">  أسم الصنف بالعربية</label>
                  </div>
                  <div class="md-form">
                    <textarea name="description" placeholder="وصف الصنف بالأنجليزية" ngModel #description="ngModel" id="form2" cols="30" rows="10" required></textarea>
                  </div>
                  <div class="md-form">
                    <textarea name="description_ar" placeholder="وصف الصنف بالعربية" ngModel #description_ar="ngModel" id="form22" cols="30" rows="10" required></textarea>
                  </div>
                  <div class="md-form">
                    <input mdbInput placeholder="ريال" ngModel name="price" #price="ngModel" type="number" id="form3" class="form-control" required>
                    <label for="form3" style="left:44%">السعر</label>
                  </div>
                  <div class="md-form">
                    <p style="text-align: center;">صورة الصنف</p>
                    <input mdbInput type="file" ngModel #photoUrl name="photoUrl" id="form58" class="form-control" required>
                  </div>
                  <input type="submit" value="أدخال" [disabled]="f2.invalid" *ngIf="addItemToMenuS == true">
                  <div class="status" *ngIf="loading == true">
                    <img src="assets/imgs/loading2.gif" style="width: 45px;">
                  </div>
                  <div class="status" *ngIf="done == true">
                    <img src="assets/imgs/done.png" style="width: 45px;">
                  </div>
                </form>            
              </div>
              <div class="modal-footer">
                <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal3.hide()" mdbWavesEffect>غلق</button>
              </div>
            </div>
          </div>
        </div>
        <!-- add item to the list modal end-->
        <div class="vincent_container vincent_typography">
          <div class="row gutters">
            <div class="col col-10 vincent_content">
          <table class="vincent_cart">
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                    <th><span>المراجعة</span></th>
                    <th><span>السعر</span></th>
                    <th><span>الصور</span></th>
                    <th><span>الوصف</span></th>
                    <th><span>الصنف</span></th>
                </tr>
            </thead>
            <tbody>
                <tr class="vincent_cart_item" *ngFor="let info of singlemenu; index as i" style="border-bottom: none;">

                        <td>
                            <a class="" (click)="basicModal5.show()"><mdb-icon far icon="edit"></mdb-icon></a>
                        </td>
                        
                        <td> 
                            <img [src]="info.photoUrl" style="width: 120px">
                        </td>

                        <td class="vincent_product-price">
                            <span  (click)="viewReviews(data.id,info.id) ">
                                <a (click)="basicModal.show()">عرض المراجعات</a>
                            </span>
                        </td>

                        <td class="vincent_product-subtotal">
                          {{info.price}}
                        </td>

                        <td class="vinvcent_product_subtotal">
                          <a (click)="basicModal2223.show()" (click)="getPhotosLength(data.id,info.id)">أضافة </a>
                        </td>
                        <td class="vincent_product-subtotal">
                            <a (click)="basicModal2222.show()" >
                                عرض الوصف
                            </a>
                        </td>
                        <td class="vincent_product-subtotal">
                          <a (click)="basicModal222233.show()">عرض الأسم</a>
                        </td>

                    <!-- edit item model-->
                    <div mdbModal #basicModal5="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-md modal-dialog-scrollable" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal5.hide()">
                              <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title w-100" id="myModalLabel">تعديل الصنف</h4>
                          </div>
                          <div class="modal-body">
                            <div>
                              <div class="md-form">
                                <input mdbInput placeholder="Item's title" [(ngModel)]="info.title" type="text" id="form1" class="form-control" (focus)="onFocus_editItemS()">
                                <label for="form1">  أسم الصنف بالأنجليزية</label>
                              </div>
                              <div class="md-form">
                                <input mdbInput placeholder="أسم الصنف" [(ngModel)]="info.title_ar" type="text" id="form11" class="form-control" (focus)="onFocus_editItemS()">
                                <label for="form11">  أسم الصنف بالعربية</label>
                              </div>
                              <div class="md-form">
                                <input mdbInput placeholder=" description" [(ngModel)]="info.description" type="text" id="form112" class="form-control" (focus)="onFocus_editItemS()">
                                <label for="form112" style="left: 40%;">   الوصف بالأنجليزية </label>
                              </div>
                              <div class="md-form">
                                <input mdbInput placeholder=" الوصف" [(ngModel)]="info.description_ar" type="text" id="form1122" class="form-control" (focus)="onFocus_editItemS()">
                                <label for="form1122" style="left: 41%;">   الوصف بالعربية </label>
                              </div>
                              <div class="md-form">
                                <input mdbInput placeholder="سعر الصنف" [(ngModel)]="info.price" type="number" id="form11222" class="form-control" (focus)="onFocus_editItemS()">
                                <label for="form11222" style="left: 45%;">   السعر  </label>
                              </div>
                              <a class="vincent_button btnX" *ngIf="editItemS == true"
                                (click)="editItem(data.id,
                                          info.id,
                                          info.title,
                                          info.title_ar,
                                          info.description,
                                          info.description_ar,
                                          info.price)">
                                            تغير
                              </a>
                              <div class="status" *ngIf="loading == true">
                                <img src="assets/imgs/loading2.gif"  class="status_cus">
                              </div>
                              <div class="status" *ngIf="done == true">
                                <img src="assets/imgs/done.png" class="status_cus">
                              </div>
                              <!-- <form #upDatePUrl (ngSubmit)=updatePhoto(data.id,info.id)>
                                <div class="md-form">
                                  <p>   صورة الصنف  </p>
                                  <input mdbInput type="file" ngModel #updatephotoUrl name="photoUrl" class="form-control" (focus)="onFocus_photoChanged()" required>
                                </div>
                                <input type="submit" value="تغير الصورة" class="vincent_button" *ngIf="photoChangedS == true" style="margin-bottom: 25px;">
                                <div class="status" *ngIf="changePhotoLoading == true">
                                  <img src="assets/imgs/loading2.gif"  class="status_cus">
                                </div>
                                <p *ngIf="photoChanged == true">تم تغير الصورة</p>
                                <br>
                              </form> -->

                            </div>
                            <a class="vincent_button" (click)="deleteItem(data.id,info.id)">حذف الصنف</a>            
                          </div>
                          <div class="modal-footer">
                            <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal5.hide()" mdbWavesEffect>غلق</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- edit item model end-->

                    <!-- Reviews model -->
                      <div mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal.hide()">
                                <span aria-hidden="true">×</span>
                              </button>
                              <h4 class="modal-title w-100" id="myModalLabel">الطلبات</h4>
                            </div>
                            <div class="modal-body">
                                <table class="vincent_cart2">
                                    <thead>
                                        <tr>
                                          <th></th>
                                            <th>
                                              <span>
                                                التقيم
                                              </span>
                                            </th>
                                            <th>
                                              <span>
                                                البريد
                                              </span>
                                              </th>
                                            <th>
                                              <span>
                                                الرسالة
                                              </span>
                                              </th>
                                            <th>
                                              <span>  
                                                الأسم 
                                              </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="vincent_cart_item" *ngFor="let review of reviews; index as i">
                                            <td><a class="vincent_button" (click)='deleteItemReview(data.id,info.id,review.id)'> حذف </a></td>
                                            <td  class="vincent_product-quantity"  data-title="Quantity">
                                                <span class="review-rating" *ngIf="review.rating == 1">★</span>
                                                <span class="review-rating" *ngIf="review.rating == 2">★★</span>
                                                <span class="review-rating" *ngIf="review.rating == 3">★★★</span>
                                                <span class="review-rating" *ngIf="review.rating == 4">★★★★</span>
                                                <span class="review-rating" *ngIf="review.rating == 5">★★★★★</span>
                                            </td>
                                            <td  class="vincent_product-quantity"  data-title="Quantity">
                                              <span>{{review.email}}</span>
                                            </td>
                                            <td  class="vincent_product-quantity"  data-title="Quantity">
                                                <span>{{review.message}}</span>
                                            </td>
                                            <td class="vincent_product-subtotal" data-title="Total">
                                                <span>{{review.name}}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="modal-footer">
                              <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal.hide()" mdbWavesEffect>غلق</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    <!-- End Reviews -->

                    <!-- Show descriptions-->
                    <div mdbModal #basicModal2222="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal2222.hide()">
                                  <span aria-hidden="true">×</span>
                                </button>
                                <h4 class="modal-title w-100" id="myModalLabel">وصف الصنف</h4>
                              </div>
                                <div class="modal-body" style="text-align:center">
                                  <h5>{{info.description}}</h5>
                                  <h5>{{info.description_ar}}</h5>                                    
                                </div> 
                                <div class="modal-footer">
                                  <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal2222.hide()" mdbWavesEffect>غلق</button>
                                </div>
                            </div>
                         
                          </div>
                    </div>
                    <!-- Show descriptions End-->
                    
                    <!-- Show name-->
                    <div mdbModal #basicModal222233="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal222233.hide()">
                              <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title w-100" id="myModalLabel">أسم الصنف</h4>
                          </div>
                            <div class="modal-body" style="text-align:center">
                              <h3>{{info.title}}</h3>
                              <h3>{{info.title_ar}}</h3>
                            </div> 
                            <div class="modal-footer">
                              <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal222233.hide()" mdbWavesEffect>غلق</button>
                            </div>
                        </div>
                     
                      </div>
                    </div>
                <!-- Show name End-->

                    <!-- Add Pics-->
                    <div mdbModal #basicModal2223="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal2223.hide()">
                              <span aria-hidden="true">×</span>
                            </button>
                            <h4 class="modal-title w-100" id="myModalLabel">أضافة صور للصنف</h4>
                          </div>
                            <div class="modal-body" style="text-align:center">
                              <form #f2="ngForm" (ngSubmit)="addPhotos(data.id,info.id)">
                                  <div class="row" style="justify-content: center;">
                                      <div class="col-md-4">
                                        <div class="button-wrapper">
                                            <span class="label">
                                                الصور
                                            </span>
                                              <br>
                                              <br>
                                              <h4>عدد الصور المتواجدة:{{photosLength}}</h4>
                                              <p class="ps-warn">*يسمح بثلاث صور فقط*</p>
                                              <input type="file" multiple id="upload" class="upload-box" placeholder="Upload File" ngModel name="gPhoto" #gPhoto required>
                                              <p class="ps-warn">*كل صورة يجيب أن يكون حجمها أقل من 10 ميجابيت*</p>
                                        </div>
                                      </div>
                                  </div>
                                  <p class="ps-alert" *ngIf="sizeAlert == true">أرجاء أختيار ثلاث صور فقط</p>
                                  <p class="ps-alert" *ngIf="lengthAlert == true">يوجد بالفعل ثلاث صور في قاعدة البيانات</p>
                                  <input type="submit" value="أضافة" class="btn btn-primary waves-light" [disabled]="f2.invalid" style="border-radius: 10px;" *ngIf="submit == true">
                                  <div *ngIf="loading == true">
                                    <img src="assets/imgs/loading2.gif" style="width: 53px; height: 53px;">
                                  </div>
                                  <div  *ngIf="done == true">
                                    <img src="assets/imgs/done.png" style="width: 53px; height: 53px;">
                                  </div>
                                
                               </form>                                  
                            </div> 
                            <div class="modal-footer">
                              <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal2223.hide()" mdbWavesEffect>غلق</button>
                            </div>
                        </div>
                     
                      </div>
                </div>
                <!-- Add Pics End-->

                </tr>
            </tbody>
          </table>
            </div>
          </div>
        </div>
          
       </ng-template>
    </ngb-tab>
  </ngb-tabset> 
</div>
